import { useDispatch, useSelector } from "react-redux";
import { MDBBtn, MDBCardTitle, MDBCol, MDBIcon, MDBInput, MDBRow } from "mdbreact";
import {
  BROWSE,
  SetReportDate,
} from "../../../../services/redux/slices/diagnostics/clinic/dailyCollections";

const CollectionsHeader = () => {
  const dispatch = useDispatch();
  const { token } = useSelector(({ auth }) => auth);
  const { reportDate, isLoading } = useSelector(
    ({ dailyCollections }) => dailyCollections,
  );

  const handleRefresh = () => {
    if (!token || !reportDate) return;

    dispatch(
      BROWSE({
        token,
        data: { date: reportDate },
      }),
    );
  };

  return (
    <MDBRow className="align-items-center mb-4">
      <MDBCol md="7" className="mb-3 mb-md-0">
        <MDBCardTitle className="mb-1 font-weight-bold">
          Daily Billing Collection Report
        </MDBCardTitle>
        <div className="text-muted small">
          Daily list of paid consultations with collection analytics.
        </div>
      </MDBCol>
      <MDBCol md="5">
        <div className="d-flex align-items-end">
          <div className="flex-grow-1 mr-2">
            <MDBInput
              label="Report Date"
              type="date"
              value={reportDate}
              onChange={({ target }) => dispatch(SetReportDate(target.value))}
            />
          </div>
          <MDBBtn
            color="primary"
            rounded
            size="sm"
            onClick={handleRefresh}
            disabled={isLoading}
            className="mb-3"
          >
            <MDBIcon icon="sync" className="mr-1" />
            Refresh
          </MDBBtn>
        </div>
      </MDBCol>
    </MDBRow>
  );
};

export default CollectionsHeader;
